import React, { useEffect, useRef, useState } from "react";
import * as PIXI from "pixi.js";
import { Spine } from "pixi-spine";
import { Skin } from "@pixi-spine/runtime-3.7/lib/runtime-3.7.js";
import keyBy from "lodash/keyBy";
import isEqual from "lodash/isEqual";
import { install } from "@pixi/unsafe-eval";

install(PIXI);

import loader from "../../lib/follower-loader.js";
import { getRgbPercentagesArrayFromString } from "../../lib/get-rgb-percentages-array-from-string.js";

const SLOTS_FOR_COLOR_APPLICATION = [
  "HEAD_SKIN_BTM",
  "HEAD_SKIN_TOP",
  "ARM_LEFT_SKIN",
  "ARM_RIGHT_SKIN",
  "LEG_LEFT_SKIN",
  "LEG_RIGHT_SKIN",
];

/**
 * https://stackoverflow.com/questions/66955027/use-an-existing-canvas-without-losing-contents-in-pixi-js
 *
 * Two possible solutions to the WebGL context issue:
 *    - Destroy context/stage after render
 *    - Use one off-screen canvas to render everything, then copy from source canvas to destination canvas inside the builder button?
 */

class FollowerRenderer extends React.Component {
  constructor(props) {
    super(props);

    this.app = new PIXI.Application({
      width: 250,
      height: 220,
      backgroundAlpha: 0,
      //backgroundColor: 0x00ff00,
    });
    this.follower = null;
    this.viewRef = React.createRef();
  }

  setSkin = (skinName) => {
    const skin = this.follower.skeleton.data.findSkin(skinName);
    this.follower.skeleton.setSkin(skin);
  };

  setColors = (color) => {
    Object.entries(color).forEach(([slotName, rgbString]) => {
      const slot = this.follower.skeleton.findSlot(slotName);

      if (slot) {
        const [r, g, b] = getRgbPercentagesArrayFromString(rgbString);

        Object.assign(slot.color, {
          r,
          g,
          b,
        });
      }
    });
  };

  componentDidMount() {
    this.viewRef.current.appendChild(this.app.view);
    this.follower = new Spine(loader.resources.follower.spineData);

    this.follower.x = this.app.screen.width / 2 + 10;
    this.follower.y = this.app.screen.height - 5;

    this.follower.state.setAnimation(0, "idle", true);
    this.follower.state.timeScale = 1;

    this.setSkin(this.props.skinName);
    this.setColors(this.props.color);
    this.app.stage.addChild(this.follower);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.follower) {
      if (prevProps.skinName !== this.props.skinName) {
        this.follower.skeleton.setSkinByName(this.props.skinName);
      }

      if (!isEqual(prevProps.color, this.props.color)) {
        this.setColors(this.props.color);
      }
    }
  }

  render() {
    return (
      <div style={{ position: "relative", zIndex: 100 }} ref={this.viewRef} />
    );
  }
}

export default FollowerRenderer;
